// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3dec91da","239":"596ae953","453":"5f611cec","849":"610dc1c4"}[chunkId] + ".chunk.js";
};